import { MapMarkerMinusIcon } from './MapMarkerMinusIcon';

/**
 * author: Simran
 * id 34DD1168-3875-4F77-9C0B-5BCFFB80FBBD
 * name map-marker-minus
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-minus.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const LocationMinusIcon = MapMarkerMinusIcon;
export default LocationMinusIcon